import { all, call, put, takeLatest, delay, race } from 'redux-saga/effects';
import {
	AdviserDetailsActionTypes,
	EmulationAdviserDetailsActionTypes,
	EmulatedUserDetailsAction,
	AdviserTryGetDetailsAction,
} from '../../store/actions/adviser.actions';
import { getDetails } from '../functions/adviserDetails.function';
import { isAuthorised } from '../functions/isAuthorised.function';
import { getOfficeUserEmulatedAdviserDetails } from '../functions/emulatedAdviserDetails.function';

export function* adviserDetailsSaga() {
	yield takeLatest(
		AdviserDetailsActionTypes.ADVISER_TRY_GET_DETAILS,
		getAdviserDetails
	);
}

export function* emulateUserDetailsSaga() {
	yield takeLatest(
		EmulationAdviserDetailsActionTypes.EMULATED_TRY_GET_OFFICE_USER_AND_ADVISER_DETAILS,
		emulateOfficeUsers
	);
}

function* emulateOfficeUsers(action: EmulatedUserDetailsAction) {
	yield put({
		type: AdviserDetailsActionTypes.ADVISER_GET_DETAILS_LOADING,
	});
	try {
		const { response, timeout } = yield race({
			response: all([
				call(() => getDetails()),
				call(() => getOfficeUserEmulatedAdviserDetails(action.emulationToken)),
			]),
			timeout: delay(THREE_SECONDS),
		});

		if (timeout) {
			yield put({
				type: AdviserDetailsActionTypes.ADVISER_GET_DETAILS_FAILURE,
			});
		}
		const [adviserDetails, officeUserEmulatedAdviserDetails] = response;

		yield put({
			type:
				EmulationAdviserDetailsActionTypes.EMULATED_GET_OFFICE_USER_AND_ADVISER_DETAILS_SUCCESS,
			adviserDetails,
			officeUserEmulatedAdviserDetails,
			emulationToken: action.emulationToken,
		});
	} catch (error) {
		yield put({
			type: AdviserDetailsActionTypes.ADVISER_GET_DETAILS_FAILURE,
		});
	}
}

const THREE_SECONDS = 3000;

export function* getAdviserDetails(action: AdviserTryGetDetailsAction) {
	yield put({
		type: AdviserDetailsActionTypes.ADVISER_GET_DETAILS_LOADING,
	});
	let retryAttemptsLeft = 3;

	while (true) {
		retryAttemptsLeft -= 1;
		if (retryAttemptsLeft < 0) {
			yield put({
				type: AdviserDetailsActionTypes.ADVISER_GET_DETAILS_FAILURE,
			});
			break;
		}

		try {
			const { response, timeout } = yield race({
				response: call(() => getDetails(action.adviserId)),
				timeout: delay(THREE_SECONDS),
			});
			if (timeout) {
				continue;
			}
			if (!isAuthorised(response)) {
				yield put({
					type: AdviserDetailsActionTypes.ADVISER_GET_DETAILS_NOT_AUTHORISED,
					response,
				});
			} else {
				yield put({
					type: AdviserDetailsActionTypes.ADVISER_GET_DETAILS_SUCCESS,
					response,
				});
				break;
			}
		} catch (statusCode) {
			if (statusCode === 401) {
				yield put({
					type: AdviserDetailsActionTypes.ADVISER_GET_DETAILS_FAILURE,
				});
				break;
			}
		}
	}
}
